
import { Component, Prop, Vue } from 'vue-property-decorator'
import { INote } from '../interface/INote'
import { State, Action, Mutation } from 'vuex-class'
import NoteEditor from '@/components/NoteEditor.vue'
import DarkModeBtn from '@/components/DarkModeBtn.vue'

function createStateProxy (instance: any) {
  return new Proxy({}, {
    get (target, attr) {
      if (!instance[attr]) {
        return undefined
      } else {
        return instance[attr]
      }
    }
  })
}

@Component({
  components: {
    NoteEditor,
    DarkModeBtn
  },
  provide () {
    const state = createStateProxy(this)
    return {
      state
    }
  }
})
export default class Note extends Vue {
  @Prop() id!: string
  @State('note') notes!: Map<string, INote>
  @State('darkMode') darkMode!: Boolean
  @Action('setNote') setNote!: (note: INote) => void
  @Mutation('noteStarToggle') noteStarToggle!: (id: String) => void
  @Mutation('modeToggle') modeToggle!: (value: boolean) => void

  tmpContent = ''
  contentTracking = 0
  get note () {
    let id = this.contentTracking
    return this.notes.get(this.id)
  }

  editorOnChange (content: string) {
    this.tmpContent = content
  }

  editorOnSave () {
    let note = this.note
    if (note) {
      note.content = this.tmpContent
      this.contentTracking += 1
      this.tmpContent = ''
    }
  }

  starToggle () {
    this.noteStarToggle(this.id)
    this.contentTracking += 1
  }

  backToList () {
    if (this.tmpContent === '') {
      this.$router.push('/')
    } else {
      let _confirm = confirm('目前內容尚未儲存，確定離開？')
      if (_confirm) {
        this.$router.push('/')
      }
    }
  }
}
